/* ─────────────────────────────
   SHIFT PRESENTATION
───────────────────────────── */

/*
 * Presentation-only helpers for shift UI.
 *
 * No Firestore access.
 * No lifecycle mutation.
 * No business authorization.
 */

export function normalizeShiftRoleKey(
  role
) {
  return String(role || "")
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_")
    .replace(/_+/g, "_");
}

export function roleColorFor(
  role
) {
  const colors = {
    CNA: {
      background: "#dbeafe",
      color: "#1e3a8a",
    },

    LVN: {
      background: "#dcfce7",
      color: "#166534",
    },

    RN: {
      background: "#fee2e2",
      color: "#991b1b",
    },

    MED_AIDE: {
      background: "#fef9c3",
      color: "#92400e",
    },

    CARE_GIVER: {
      background: "#ccfbf1",
      color: "#0f766e",
    },
  };

  const roleKey =
    normalizeShiftRoleKey(
      role
    );

  return (
    colors[roleKey] || {
      background: "#e5e7eb",
      color: "#111827",
    }
  );
}